import { moduleProviderFactory } from "core/providers";
import { FacilityMissingDocsSearch, FacilityMissingDocsPreview } from "application/facility-missing-docs/pages";
import { PatientMissingDocsPreview } from "application/patient-missing-docs/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-missing-docs",
				pattern: "/facility-missing-docs",
                children: [
					{
						name: "master.app.main.facility-missing-docs.search",
						pattern: "/search",
						authorization: "facilityOrderSection.read",
						component: FacilityMissingDocsSearch,
						tabTitle: "MENU.FACILITY_MISSING_DOCS_SUB",
					},
					{
						name: "master.app.main.facility-missing-docs.preview",
						pattern: "/preview/:id/showOnlyPastTemplates/:showOnlyPastTemplates",
						component: FacilityMissingDocsPreview,
						authorization: "facilityOrderSection.update",
						data: {
							crumbs: [
								{
									title: "FACILITY_MISSING_DOCS.CRUMB.FACILITY_PREVIEW",
									route: 'master.app.main.facility-missing-docs.preview'
								}
							],
							back: "master.app.main.facility-missing-docs.search"
						},
					},
					{
						name: "master.app.main.facility-missing-docs.patient-preview",
						pattern: "/patient-preview/:id",
						component: PatientMissingDocsPreview,
						authorization: "facilityOrderSection.update",
						data: {
							crumbs: [
								{
									title: "PATIENT_MISSING_DOCS.CRUMB.PATIENT_PREVIEW",
									route: 'master.app.main.facility-missing-docs.patient-preview'
								}
							],
							back: "master.app.main.facility-missing-docs.search"
						},
					},
                ]
            }
        ],
		menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_MISSING_DOCS_SUB",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-missing-docs.search",
						order: 6,
					}
				]
			},
        ]
    });
})();
